"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWorkspaceCreateSibling = exports.WORKSPACE_CREATE_SIBLING_ERRORS = void 0;
const expected_errors_1 = require("@app/request/auth/expected-errors");
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var WORKSPACE_CREATE_SIBLING_ERRORS;
(function (WORKSPACE_CREATE_SIBLING_ERRORS) {
    /** another workspace in the organization already has this name (trimmed, case-insensitive) */
    WORKSPACE_CREATE_SIBLING_ERRORS["NAME_EXISTS"] = "workspace.nameExists";
})(WORKSPACE_CREATE_SIBLING_ERRORS || (exports.WORKSPACE_CREATE_SIBLING_ERRORS = WORKSPACE_CREATE_SIBLING_ERRORS = {}));
const WORKSPACE_CREATE_SIBLING_MUTATION = (0, graphql_tag_1.default) `
  mutation WorkspaceCreateSiblingMutation($workspace: ID!, $name: String!) {
    workspaceCreateSibling(workspace: $workspace, name: $name) {
      id
      name
      organizationId
    }
  }
`;
const requestWorkspaceCreateSibling = async (variables, errorsCallback) => {
    const { expectedErrors, ...VARIABLES } = variables;
    const { data, errors } = await (0, apollo_1.mutate)(WORKSPACE_CREATE_SIBLING_MUTATION, { variables: VARIABLES });
    (0, expected_errors_1.processUnexpectedErrors)(errors, expectedErrors);
    errorsCallback?.(errors);
    return data?.workspaceCreateSibling ?? undefined;
};
exports.requestWorkspaceCreateSibling = requestWorkspaceCreateSibling;
exports.default = exports.requestWorkspaceCreateSibling;
